import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, ViewChildren, ChangeDetectorRef, Input, isDevMode, OnDestroy } from '@angular/core';
import { FirebaseService } from '../../service/firebase.service';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';

import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { UtilsService } from '../../services/utils.service';
import { SharedService } from '../../services/shared.service';
import { MatDialog } from '@angular/material/dialog';
import { ListSelectionModalComponent } from '../../modals/list-selection-modal/list-selection-modal.component';
import { ModalMainComponent } from '../../modals/modal-main/modal-main.component';
import { TagsmanagementComponent } from '../../modals/tagsmanagement/tagsmanagement.component';
import { ConfirmModalComponent } from '../../modals/confirm-modal/confirm-modal.component';
import { ContentListComponent } from './content-list/content-list.component';
import { TranslationPipe } from '../../shared/pipes/translation.pipe';
import * as Excel from 'exceljs'
import { Buffer } from 'buffer'
import { ListSelectDeviceComponent } from '../../modals/list-select-device/list-select-device.component';
@Component({
  selector: 'app-media',
  templateUrl: './media.component.html',
  styleUrls: ['./media.component.scss']
})
export class MediaComponent implements OnInit, AfterViewInit, OnDestroy {
  public selectedFolder: any = {};
  public pathDisplay: string = '';
  public contentArray: any = [];
  folderArray = [];
  public contentData: any;
  public moduleId: any;

  private config: any;
  private dialogRef;
  private selectedMedia: any;
  public defaultBackgroundColor: any;


  public folderBackgroundAssetsUrl: any;
  public folderThumbnailAssetsUrl: any;
  public logoUrl: any;
  public buttonSize: any;
  public mediaStyle: string = "";
  public displayStyle: string = "";
  public latestUpdate: any;
  public backupData: any;
  public enableHeader: boolean = true;
  public hideElementName: boolean = false;
  loadingBackgroundThumbnail: boolean = true;
  loadingThumbnail: boolean = true;
  loadingLogo: boolean = true;
  excelData: any;

  excelUploadEnable: Array<string> = ['Xn9nWDRPeQdK4XhKEZH7Nvv5IIa2', 'OvOSoNvxFcd2KDbsLQls32kaveW2']


  @ViewChildren('backgroundThumbnail') backgroundThumbnail: ElementRef;
  @ViewChildren('thumbnail') thumbnail: ElementRef;
  @ViewChild('uploadMediaThumbnail') uploadMediaThumbnailInput: ElementRef;

  @ViewChild('contentList') contentDisplayList: ContentListComponent;


  constructor(private _utils: UtilsService, public translation: TranslationPipe, public _firebase: FirebaseService, private _sharedVar: SharedService, private _ref: ChangeDetectorRef, public dialog: MatDialog) {





  }
  isDevModeCustom() {
    return isDevMode()
    console.log(isDevMode())
  }

  ngOnDestroy() {
    this._firebase.cleanModuleSnapshot();
  }

  changeButtonSize() {
    // console.log(this.buttonSize)

    this._firebase.updateConfigModule({ buttonSize: this.buttonSize, latestUpdate: this.latestUpdate }, this.moduleId).then(d => {
      this.latestUpdate = d;
    })
  }


  saveMediaBackup() {
    let fileUrlArray: Array<any> = [];

    this.dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '30vw',
      height: '30vh',
      data: { title: this.translation.transform('confirmSaveBackupOperation'), ok: 'OK', cancel: 'Annuler' }
    })


    this.dialogRef.afterClosed().subscribe(result => {
      //console.log(result)
      if (result) {
        let loopTrough = (tab) => {

          //console.log(tab)

          tab.forEach((elem, index) => {
            if (elem.children != undefined && elem.children.length > 0) {
              loopTrough(elem.children)
            }


            let eachRecursive = (obj) => {
              for (var k in obj) {
                let url;

                try {
                  url = new URL(obj[k]);
                } catch (err) {
                }

                if (url && url.host == 'firebasestorage.googleapis.com')
                  fileUrlArray.push(obj[k])

                if (typeof obj[k] == "object" && obj[k] !== null)
                  eachRecursive(obj[k]);
                else { }
              }

            }

            eachRecursive(elem)

          })
        }

        loopTrough(this.contentArray)
        this.backupData = { fileTree: this.contentArray, urlImageBackUpArray: fileUrlArray, latestBackup: new Date() }
        this._firebase.updateConfigModule({ backup: this.backupData, latestUpdate: this.latestUpdate }, this.moduleId).then(d => {
          this.latestUpdate = d;

        })
      }


    })



  }

  restraintAccess() {

    return true;
    let banArray = ['ZicEdhnFrscMjlXKtP6dYnYuYi73']
    // console.log(this._firebase.user.uid)
    return banArray.includes(this._firebase.user.uid)

  }

  loadMediaBackup() {
    //console.log(this.backupData.fileTree)


    this.dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '30vw',
      height: '30vh',
      data: { title: this.translation.transform('confirmLoadBackupOperation'), ok: 'OK', cancel: 'Annuler' }
    })

    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let loopTrough = (tab) => {

          // console.log(tab)

          tab.forEach((elem, index) => {
            if (elem.children != undefined && elem.children.length > 0) {
              loopTrough(elem.children)
            }

            //console.log(elem.id)


            this._firebase.checkIfDocExist(elem.id).then(d => {
              //  console.log(d.exists, elem.id)

              if (!d.exists) {
                this._firebase.setMedia(elem.id, elem.mediaOptions)
              }

            })



          })
        }

        loopTrough(this.backupData.fileTree);



        //console.log("LOAD BACKUP", this.backupData.fileTree)
        this.contentArray = this.backupData.fileTree;

        this._firebase.updateConfigModule({ fileTree: this.contentArray, latestUpdate: this.latestUpdate }, this.moduleId).then(d => {
          this.latestUpdate = d;
        })
      }
    })


  }



  async managerExcelFile(e) {
    //console.log(e.target.files)
    let excelData = [];
    var reader = new FileReader();
    reader.readAsArrayBuffer(e.target.files[0]);
    reader.onload = async (evt) => {
      let ab = evt.target.result as any;

      let buffer = Buffer.from(new Uint8Array(ab));

      const workbook = new Excel.Workbook();
      await workbook.xlsx.load(buffer).then(d => {



        //  console.log(d.worksheets)


        let worksheetName = d.worksheets.map(e => e.name);

        //console.log(worksheetName)



        worksheetName.forEach((item) => {
          let worksheet = d.getWorksheet(item);

          let data = worksheet.getRows(0, (worksheet.rowCount - 1)).map(v => v.values[1]).filter(v => v != undefined)



          excelData.push({ name: item, data: data });

        })


        let finalData = { data: excelData, latestUpdate: new Date() }


        this._firebase.updateConfigModule({ excelData: finalData, latestUpdate: this.latestUpdate }, this.moduleId).then(d => {
          this.latestUpdate = d;
          this.excelData.latestUpdate = this.latestUpdate;
        })
        //console.log(finalData)
        /*
        let worksheetP = d.getWorksheet('patients');
 
 
        let patientsName = worksheetP.getRows(0, (worksheetP.rowCount - 1)).map(v => v.values[1]).filter(v => v != undefined)
 
 
    //    this._sharedVar.setElectronStorage('kids', { data: patientsName })
 
 //       this.kids = patientsName
 
        let worksheetT = d.getWorksheet('taxis ambulances');
        let transportName = worksheetT.getRows(0, (worksheetT.rowCount - 1)).map(v => v.values[1]).filter(v => v != undefined)
 
    //    this._sharedVar.setElectronStorage('transport', { data: transportName })
 
  //      this.transports = transportName
        console.log(patientsName, transportName)*/
      });
      //   console.log(buffer)
    }

    /*
         let data = Buffer.from(evt.target.result)
    
          const workbook = new Excel.Workbook();
          await workbook.xlsx.load(evt.target.result);*/




  }


  setSelectedFolder(d) {
    console.log(d)
    this.contentArray = [];
    this.selectedFolder = {};
    //   this.folderBackgroundAssetsUrl = null;
    // this.folderThumbnailAssetsUrl = null;
    //  console.log(d.node)
    console.log(d, this.contentData)
    // alert("SET SELECTED FOLDER")
    if (d.node != null) {

      let tmpSelectedFolder = d.node
    //  this.selectedFolder = d.node;







      this.pathDisplay = tmpSelectedFolder.path.replace(/\//g, ' > ');

      this.pathDisplay = "Accueil" + this.pathDisplay.substring(1, this.pathDisplay.length) + ' > ' + tmpSelectedFolder.name


      console.log(d)
      this.contentData = d.contentData;

      let loopThrough = (tab) => {
        tab.forEach(item => {

          if (item.displayName == undefined || item.displayName.length == 0)
            item.displayName = item.name

          if (item.children != undefined && item.children.length > 0)
            loopThrough(item.children)




        })
      }
      loopThrough(this.contentData)

      //  console.log(d.contentData)
      this._utils.getContentFromFolder(d.contentData, tmpSelectedFolder.id).then((d) => {
        this.contentArray = d;

        //     console.log("GET CONTENT FROM FOLDER")
        /*  this.contentArray.forEach((item) => {
             //console.log(item)
          })*/

        //    console.log("DATA MEDIA TEST", d)
        this.setContentData(this.contentArray).then(mediaData => {
          console.log("MEDIADATA", mediaData)
          /*    if (this.contentDisplayList != undefined)
              this.contentDisplayList.initTable();*/
          // console.log("SET CONTENT DATA:", this.contentArray, mediaData)
          if (this.contentDisplayList)
            this.contentDisplayList.checkIfContentDataAsMediaOptions(mediaData);

        });

        // console.log('contentArray', this.contentArray)

      })

      this._firebase.getMedia(tmpSelectedFolder.id).then((d: any) => {
        let data = d.data();
        //   console.log(data)

        this.selectedFolder = tmpSelectedFolder
        this.selectedFolder.mediaOptions = data;
   //     Object.assign(this.selectedFolder, tmpSelectedFolder)
        if (!data)
          return
        if (d.data() && d.data().defaultColor)
          this.defaultBackgroundColor = d.data().defaultColor;
        //console.log(data)
        /// console.log("SET ACTIVE FOLDER:", data, d.id)
        //  console.log(d.data().background.url, d.data().thumbnail.url)
        if (this.folderBackgroundAssetsUrl != data.background.url) {
          this.folderBackgroundAssetsUrl = data.background.url;
          this.loadingBackgroundThumbnail = false;
        }
        if (this.folderThumbnailAssetsUrl != data.thumbnail.url) {
          this.folderThumbnailAssetsUrl = data.thumbnail.url
          this.loadingThumbnail = false;
        }


        console.log("DATA", data.hideElement);
        if (data.hideElementName) {
          this.hideElementName = data.hideElementName
        }
        else {
          this.hideElementName = false;
        }
        //  this._ref.detectChanges()

        this.contentDisplayList.initTable();
        //    this.manageDisplayThumbnail();
        /*  console.log("SET FOLDER", this.thumbnail, this.backgroundThumbnail, this.folderBackgroundAssetsUrl)
          if (this.thumbnail != undefined)
            this.thumbnail.nativeElement.onerror = (err) => {
  
              console.log("ERROR DISPLAY THUMBNAIL:", err, this.backgroundThumbnail.nativeElement)
              this.thumbnail.nativeElement.style.display = "none";
  
              this.loadingThumbnail = false;
            }
  
          if (this.backgroundThumbnail != undefined)
            this.backgroundThumbnail.nativeElement.onerror = (err) => {
              console.log("ERROR DISPLAY BACKGROUND:", err, this.backgroundThumbnail.nativeElement)
              this.backgroundThumbnail.nativeElement.style.display = "none";
              this.loadingBackgroundThumbnail = false;
            }*/

      })


      if (!this.latestUpdate && this._firebase.user.assignedDevice && this._firebase.user.role == 'subuser')
        this._firebase.getModuleFromDevice('media', this._sharedVar.selectedDevice.data.group, this._sharedVar.selectedDevice.data.name).then(d => {
          this.latestUpdate = d.data.latestUpdate
        })

    }
    else {
      this.pathDisplay = "Accueil"
      console.log(this._sharedVar.selectedDevice.data.group, this._sharedVar.selectedDevice.data.name)
      this._firebase.getModuleFromDevice('media', this._sharedVar.selectedDevice.data.group, this._sharedVar.selectedDevice.data.name).then(d => {
        //    console.log(d.data.fileTree)

        //     alert("ACCUEIl")
        this.config = d.data;
        //console.log(this.config)
        if (this.config.enableHeader == undefined)
          this.config.enableHeader = true;
        this.defaultBackgroundColor = d.data.defaultColor;
        //     console.log(this.config)
        this.latestUpdate = d.data.latestUpdate
        this.contentData = d.data.fileTree
        this.contentArray = d.data.fileTree;
        this.logoUrl = d.data.logoUrl
        this.mediaStyle = d.data.mediaStyle
        this.displayStyle = d.data.displayStyle
        this.enableHeader = d.data.enableHeader
        this.hideElementName = d.data.hideElementName
        this.buttonSize = d.data.buttonSize;

        if (d.data.excelData) {
          this.excelData = d.data.excelData
          console.log(this.excelData.latestUpdate)


          try {
            this.excelData.latestUpdate = this.excelData.latestUpdate.toDate() || this.parseObjectToDate(this.excelData.latestUpdate)
          } catch (err) {
            ;
          }
          // || 


        }

        //      console.log("EXCEL DATA:", this.excelData)
        if (d.data.backup) {
          this.backupData = d.data.backup


          if (d.data.backup.latestBackup.nanoseconds) {

            d.data.backup.latestBackup = new Date(d.data.backup.latestBackup.seconds * 1000 + d.data.backup.latestBackup.nanoseconds / 1000000);
          }

          //   this.backupData.latestBackup = 
        }



        if (this.mediaStyle == undefined)
          this.mediaStyle = 'full'

        if (this.displayStyle == undefined)
          this.displayStyle = "default"


        console.log(this.displayStyle)
        if (this.buttonSize == undefined)
          this.buttonSize = 'big'

        let loopThrough = (tab) => {
          tab.forEach(item => {

            if (item.displayName == undefined || item.displayName.length == 0)
              item.displayName = item.name

            if (item.children != undefined && item.children.length > 0)
              loopThrough(item.children)


            //     console.log(item)
          })
        }
        loopThrough(this.contentData)

        // console.log("LOGO URL:", this.logoUrl)
        this.setContentData(d.data.fileTree).then(n => {
          //    console.log("RICH MEDIA TO DISPLAY:", n)
          //   console.log("SET CONTENT DATA ACCUEIL:", n)
          console.log("SET CONTENT DATA", n)
          if (n.length > 0)
            this.contentDisplayList.checkIfContentDataAsMediaOptions(JSON.parse(JSON.stringify(n)));

          /*     if (this.contentDisplayList != undefined)
               this.contentDisplayList.initTable();*/


        })
        //  console.log(this.config)
        this.selectedFolder = 'root';
        if ((this.selectedFolder == 'root' || this.selectedFolder == undefined) && this.folderBackgroundAssetsUrl != this.config.rootBackgroundAsset) {

          this.folderBackgroundAssetsUrl = this.config.rootBackgroundAsset;

          this.loadingBackgroundThumbnail = false;
          this.loadingThumbnail = false;
        }

        //   this.manageDisplayThumbnail();


      })





      // this.contentDisplayList.initTable();
      /* this._utils.getRootContent().then(d => {
 
       })*/


    }



  }








  /*drop(event: CdkDragDrop<string[]>) {
    let previousIndex = event.item.data;




    //console.log(typeof (event.container.data))
    let nextIndex = event.container.data as any;

    moveItemInArray(this.contentArray, previousIndex, nextIndex);

   /* if (event.previousContainer === event.container) {

      //   console.log(event.container.data)

      moveItemInArray(this.contentArray, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }
    // console.log(this.contentArray);


  //  if (this.selectedFolder.id != undefined) {
      //   console.log(this.selectedFolder.id)


      // console.log(this.contentData);


    console.log(this.contentArray, this.contentData, this.selectedFolder.id)
    this._firebase.updateConfigModule({ fileTree: this.contentData }, this.moduleId);

    /*  this._utils.replaceAllChildren(this.contentData, this.selectedFolder.id, this.contentArray).then(d => {
        //   console.log(d)


        this._firebase.updateConfigModule({ fileTree: this.contentData }, this.moduleId);


      })
  //  }

    //  console.log(this.selectedFolder)
    console.log("SRC", event.item.data, "DEST", event.container.data)
  }*/

  parseObjectToDate(data) {
    let res = null;
    if (data.seconds && data.nanoseconds)
      res = new Date(res.seconds * 1000 + res.nanoseconds / 1000000)//.toUTCString()

    return res;
  }

  eventManager(e) {
    console.log(e)

    if (e.type == 'uploadThumbnail')
      this.uploadThumbnail(e.item)
    if (e.type == 'deleteThumbnail') {
      this.deleteThumbnail(e.item)
    }
    if (e.type == 'rename') {
      this.refreshDataFromServer();
    }

  }

  uploadThumbnail(item) {
    //  console.log(item)
    this.uploadMediaThumbnailInput.nativeElement.click()
    this.selectedMedia = item;

  }

  deleteThumbnail(item) {
    //  console.log(item)
    //  this.uploadMediaThumbnailInput.nativeElement.click()
    this.selectedMedia = item;

    this._firebase.deleteThumbnailFileFromUrl(item.mediaOptions.thumbnail.url)

    this._firebase.updateMediaData({ thumbnail: { url: "", name: "" } }, this.selectedMedia.id).then((d) => {


      let loopThrough = (tab) => {
        tab.forEach(item => {

          if (item.id == this.selectedMedia.id) {
            if (item.type == 'folder')
              delete item.mediaOptions;
            item.thumbnailAssetName = null;
          }
          /*  if (item.displayName == undefined || item.displayName.length == 0)
              item.displayName = item.name
*/
          if (item.children != undefined && item.children.length > 0)
            loopThrough(item.children)
        })
      }
      loopThrough(this.contentData)


      //     console.log("MODULE ID:", this.moduleId)
      this._firebase.updateModule(this.moduleId, { fileTree: this.contentData, latestUpdate: new Date() });
      this.refreshDataFromServer();
      // this.uploadMediaThumbnailInput.nativeElement.value = null;
      //   this.set
    })
  }

  uploadHeaderLogo(e, type) {
    let file = e.target.files
    //  console.log(file[0].name)
    file[0].name = 'logo.' + file[0].name.split('.')[1]


    /* this._firebase.uploadFiles(file, 'media').then((data) => {
       data.forEach((elem) => {
       //  console.log(elem, this.selectedMedia)
 
         let tmpSplit = elem.path.split('/');
 
 
         let filename = elem.path.split('/')[tmpSplit.length - 1]
         this._firebase.updateMediaData({ thumbnail: { url: elem.url, name: filename } }, this.selectedMedia.id).then((d) => {
 
 
           console.log("MODULE ID:", this.moduleId)
           this._firebase.updateModule(this.moduleId, { latestUpdate: new Date() });
           this.refreshDataFromServer();
           this.uploadMediaThumbnailInput.nativeElement.value = null;
           //   this.set
         })
       })
 
     })*/
  }

  upMediaThumbnail(e) {

    let file = e.target.files
    //   console.log(e, this.selectedMedia)

    this._firebase.uploadFiles(file, 'media').then((data) => {
      data.forEach((elem) => {
        //       console.log(elem, this.selectedMedia)

        let tmpSplit = elem.path.split('/');


        let filename = elem.path.split('/')[tmpSplit.length - 1]

        let tmpElem = {};
        if (this.selectedMedia.type == 'folder') {
          tmpElem = { url: elem.url, firestoragePath: `users/${this._firebase.user.displayName}/media/${filename}` };
        }
        else {
          tmpElem = { url: elem.url, name: filename };
        }

        this._firebase.updateMediaData({ thumbnail: tmpElem }, this.selectedMedia.id).then((d) => {




          let loopThrough = (tab) => {
            tab.forEach(item => {

              if (item.id == this.selectedMedia.id) {
                item.thumbnailAssetName = filename;

                if (item.type == 'folder')
                  delete item.mediaOptions;
              }
              /*  if (item.displayName == undefined || item.displayName.length == 0)
                  item.displayName = item.name
  */
              if (item.children != undefined && item.children.length > 0)
                loopThrough(item.children)
            })
          }
          loopThrough(this.contentData)

          this._firebase.updateModule(this.moduleId, { fileTree: this.contentData, latestUpdate: new Date() });
          this.refreshDataFromServer();
          this.uploadMediaThumbnailInput.nativeElement.value = null;
          //   this.set
        })
      })

    })

    //console.log(e)
  }

  canAddThumbnail(item) {
    if (item.name.match(/\.(mp4)$/)) {
      return true
    }
    else if (item.name.match(/\.(pdf)$/)) {
      return true
    }
  }


  getFileUrl(item) {
    //  console.log("TYPE:", item.type, item)
    if (item.name.match(/\.(jpeg|jpg|gif|png)$/)) {
      if (item.mediaOptions)
        return item.mediaOptions.url
      else
        return item.url
    }
    else if (item.name.match(/\.(mp4|pdf)$/) || item.type == 'quiz') {
      //    console.log("THIS IS A VIDEO", item)
      if (item.mediaOptions && item.mediaOptions.thumbnail)
        return item.mediaOptions.thumbnail.url;
      else
        return null
    }
    else if (item.type == 'web') {
      if (item.mediaOptions != undefined)
        return item.mediaOptions.thumbnailUrl
      else
        return null;
    }
    return null
  }

  moveTo(id) {



    /*let elems = this._utils.getAllNestedArrayElement(this.dataSource, id);
 
    console.log("MOVE TO:", elems)*/


    this.dialogRef = this.dialog.open(ListSelectionModalComponent, {

      height: '50vh',
      data: { data: this.contentData, id: id, type: "folder", buttonLabel: 'OK' }
    })

    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {

        if (result.currentValue[0].root) {

          let elem = this._utils.getFolderFromId(this.contentData, id)

          this._utils.deleteElementFromNestedArray(this.contentData, id);

          this.contentData.push(elem);

        }
        else {
          let targetId = result.currentValue[0].id;

          this._utils.moveElement(this.contentData, targetId, id)
        }




        this._firebase.updateConfigModule({ fileTree: this.contentData, latestUpdate: this.latestUpdate }, this.moduleId).then(d => {
          this.latestUpdate = d;
        })

      }
    });
  }

  setContentData(d) {
    let promiseArray: any = [];

    /* this.loadingBackgroundThumbnail = true;
     this.loadingThumbnail = true;*/
    /*  this.folderBackgroundAssetsUrl = null;
      this.folderThumbnailAssetsUrl = null;*/
    return new Promise<any>((resolve, reject) => {
      d.forEach((item) => {
        promiseArray.push(this._firebase.getMedia(item.id).then(mediaData => {
          console.log("SETCONTENDATA GET MEDIA ELEMENT", mediaData.data())
          item.mediaOptions = mediaData.data();



          //console.log(item)
        }))
      })

      // console.log(d)

      //  console.log(promiseArray)



      return Promise.all(promiseArray).then(a => {
        resolve(d)
      })
    })



  }

  applyToAllDeviceFromGroup() {
    //  console.log(this.contentData,)
    let saveData = JSON.parse(JSON.stringify(this.contentData));

    this.dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '30vw',
      height: '30vh',
      data: { title: this.translation.transform('confirmOperation'), ok: 'OK', cancel: 'Annuler' }
    })


    this.dialogRef.afterClosed().subscribe((result) => {

      if (result) {

        let tmp = { fileTree: this.contentData, logoUrl: this.logoUrl, mediaStyle: this.mediaStyle, buttonSize: this.buttonSize, rootBackgroundAsset: this.folderBackgroundAssetsUrl, latestUpdate: new Date() }




        this._firebase.updateMediaSettingsOfAllGroup(tmp, this._sharedVar.selectedDevice.data.group, this._sharedVar.selectedDevice.data.name, this.backupData);
      }

      else {

      }

    })

    //   this._firebase.cleanData(saveData);
    /**/



    // console.log(tmp)
  }

  applyToSelectedDevice() {
    let saveData = JSON.parse(JSON.stringify(this.contentData));
    this.dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '30vw',
      height: '30vh',
      data: { title: this.translation.transform('confirmOperation'), ok: 'OK', cancel: 'Annuler' }
    })


    this.dialogRef.afterClosed().subscribe((result) => {

      if (result) {

        this.dialogRef = this.dialog.open(ListSelectDeviceComponent, {
          width: '30vw',
          height: '50vh',
          data: { title: this.translation.transform('warningApplyToDevice'), ok: 'OK', cancel: this.translation.transform('cancel'), selectedDevice: this._sharedVar.selectedDevice }
        })


        this.dialogRef.afterClosed().subscribe((selectedDevice) => {

          console.log(selectedDevice)
          console.log(selectedDevice)


          console.log("CONTENT TO COPY", JSON.parse(JSON.stringify(this.contentData)), this.contentData)

          if (selectedDevice) {
            let tmp = { fileTree: JSON.parse(JSON.stringify(this.contentData)), logoUrl: this.logoUrl, mediaStyle: this.mediaStyle, buttonSize: this.buttonSize, rootBackgroundAsset: this.folderBackgroundAssetsUrl, latestUpdate: new Date() }


            this.contentDisplayList.isWorking = true;

            this._firebase.updateMediaSettingsOfDevice(tmp, this._sharedVar.selectedDevice.data.group, this._sharedVar.selectedDevice.data.name, this.backupData, selectedDevice).then(d => {
              this.contentDisplayList.isWorking = false;
            });
            console.log(this.contentData)
          }
        })
      }

    })

  }

  onChange(e) {
    // console.log(e.target.files[0])
    let file = e.target.files
    /*  console.log(files.length)
      if (files.length > 1)
        this._firebase.multiUpload(files, 'media').then((urls) => {
  
        })
      else {
        let file = files[0]*/
    // for (let file of files) {

    this._firebase.uploadFiles(file, 'media').then((data) => {


      let promises: any = []

      data.forEach((elem) => {
        promises.push(this._firebase.addMedia('file', elem.data.name, { defaultName: elem.defaultName, path: `${this.selectedFolder.path}/${this.selectedFolder.name}`, firePath: `users/${this._firebase.user.displayName}/media`, url: elem.url }).then((d) => {
          //  console.log("DATA ADD MEDIA:", d)

          //console.log(this.selectedFolder)
          if (this.selectedFolder == 'root') {
            // console.log("UPLOAD TO ROOT", { name: file.name, url: url, id: d.id, path: `.`, type: 'file' }, this.contentData)

            this.contentData.push({ name: elem.data.name, displayName: elem.defaultName, url: elem.url, id: d.id, path: `.`, type: 'file' });
            // this._firebase.updateConfigModule({ fileTree: this.contentData }, this.moduleId)


          }

          else
            this._utils.addFileToModuleData(this.contentData, this.selectedFolder.id, { name: elem.data.name, displayName: elem.defaultName, id: d.id, path: `${this.selectedFolder.path}/${this.selectedFolder.name}`, type: 'file' }).then((content) => {

              //      console.log("THIS IS CONTENT:", content);
              //  this._firebase.updateConfigModule({ fileTree: [{ type: 'folder', path: '.', firestoreId: e.id, children: [] }] }, d.id)
              //   this._firebase.updateConfigModule({ fileTree: content }, this.moduleId)
            })

        }))

      })

      Promise.all(promises).then(d => {
        this.refreshDataFromServer();
        let tmp = JSON.parse(JSON.stringify(this.contentData));







        tmp = this._utils.cleanData(tmp)

        this._firebase.updateConfigModule({ fileTree: tmp, latestUpdate: this.latestUpdate }, this.moduleId).then(d => {
          this.latestUpdate = d;
        })
      })
      /*
        this._firebase.addMedia('file', file.name, { path: `${this.selectedFolder.path}/${this.selectedFolder.name}`, firePath: `users/${this._firebase.user.displayName}/media`, url: url }).then((d) => {
          //  console.log("DATA ADD MEDIA:", d)

          //console.log(this.selectedFolder)
          if (this.selectedFolder == 'root') {
            // console.log("UPLOAD TO ROOT", { name: file.name, url: url, id: d.id, path: `.`, type: 'file' }, this.contentData)

            this.contentData.push({ name: file.name, url: url, id: d.id, path: `.`, type: 'file' });
            this._firebase.updateConfigModule({ fileTree: this.contentData }, this.moduleId)

          }

          this._utils.addFileToModuleData(this.contentData, this.selectedFolder.id, { name: file.name, id: d.id, path: `${this.selectedFolder.path}/${this.selectedFolder.name}`, type: 'file' }).then((content) => {

            //      console.log("THIS IS CONTENT:", content);
            //  this._firebase.updateConfigModule({ fileTree: [{ type: 'folder', path: '.', firestoreId: e.id, children: [] }] }, d.id)
            this._firebase.updateConfigModule({ fileTree: content }, this.moduleId)
          })


        })*/
    }).catch((err) => {
      console.log(err);
    })
    // }
    // }



  }



  /* deleteMedia(elem) {
 
 
 
     if (elem.type == 'file')
       this._firebase.getDocDataAndDeleteFile(elem.id)
     else
       this._firebase.deleteMedia(elem.id)
 
     this._utils.deleteElementFromNestedArray(this.contentData, elem.id)
     this._firebase.updateConfigModule({ fileTree: this.contentData }, this.moduleId)
   }*/

  setModuleId(id) {
    this.moduleId = id
  }

  uploadFolderAssets(e, type, url = null) {

    // console.log(this.contentData)
    // console.log(this.selectedFolder)
    // console.log("UPLOAD FOLDER ASSET")




    let rootAsset;

    //  console.log(this.selectedFolder)
    if (this.selectedFolder != 'root' && type != 'logo')
      rootAsset = null;
    else if (type == 'logo')
      rootAsset = this.config.logoUrl
    else
      rootAsset = this.config.rootBackgroundAsset;

    if (url != null)
      rootAsset = url;

    // console.log(this.config, rootAsset)
    //  console.log("THIS IS BEFORE REMOVE PREVIOUS IMAGE")
    this._firebase.removePreviousImg(this.selectedFolder.id, type, rootAsset).then(() => {
      this._firebase.uploadFiles(e.target.files, 'media').then((data) => {
        let d = data[0].url

        let getFilenameFromUrl = (url) => {
          // Create a URL object
          const parsedUrl = new URL(url);
          // Get the pathname and extract the last segment
          const pathname = parsedUrl.pathname;
          const filename = decodeURIComponent(pathname.split('/').pop());
          return filename.split('/').pop();
        }


        let path = `users/${this._firebase.user.displayName}/media/` + `${getFilenameFromUrl(d)}`

        //  console.log(type)
        if (type == 'background') {


          if (this.selectedFolder == undefined || this.selectedFolder.id == undefined || this.selectedFolder.id == null) {

            this.folderBackgroundAssetsUrl = d;
            this._firebase.updateConfigModule({ fileTree: this.contentData, rootBackgroundAsset: d, latestUpdate: this.latestUpdate }, this.moduleId).then(d => {
              this.latestUpdate = d;
            })


            let tmp = document.getElementById('uploadBackground') as any

            //          console.log(tmp)
            tmp.value = "";
            //  this.manageDisplayThumbnail();
          }
          else {
            this._firebase.updateMediaData({ background: { firestoragePath: path, url: d } }, this.selectedFolder.id)
            this.folderBackgroundAssetsUrl = d;



            this._utils.updateElement(this.contentData, this.selectedFolder.id, 'backgroundAssetName', getFilenameFromUrl(d) /*e.target.files[0].name*/)
            this._firebase.updateConfigModule({ fileTree: this.contentData, latestUpdate: this.latestUpdate }, this.moduleId).then(d => {
              this.latestUpdate = d;
            })

            let tmp = document.getElementById('uploadBackground') as any
            //    console.log(tmp)
            tmp.value = "";
            //   this.manageDisplayThumbnail();
          }


        }
        else if (type == 'thumbnail') {

          this._firebase.updateMediaData({ thumbnail: { firestoragePath: path, url: d } }, this.selectedFolder.id)
          this.folderThumbnailAssetsUrl = d;

          this._utils.updateElement(this.contentData, this.selectedFolder.id, 'thumbnailAssetName', getFilenameFromUrl(d))
          this._firebase.updateConfigModule({ fileTree: this.contentData, latestUpdate: this.latestUpdate }, this.moduleId).then(d => {
            this.latestUpdate = d;
          })


          let tmp = document.getElementById('uploadThumbnail') as any
          // console.log(tmp)
          tmp.value = "";
        }
        else if (type == 'logo') {

          /*  console.log(path, d)
            if (this.selectedFolder != undefined || this.selectedFolder.id == undefined || this.selectedFolder.id == null || this.selectedFolder == {}) {
  
            }
            
            this._firebase.updateMediaData({ thumbnail: { firestoragePath: path, url: d } }, this.selectedFolder.id)*/
          this.logoUrl = d;



          //this._utils.updateElement(this.contentData, this.selectedFolder.id, 'logo', e.target.files[0].name)
          this._firebase.updateConfigModule({ logoUrl: this.logoUrl, latestUpdate: this.latestUpdate }, this.moduleId).then(d => {
            this.latestUpdate = d;
          })
          let tmp = document.getElementById('uploadThumbnail') as any
          //       console.log(tmp)
          if (tmp)
            tmp.value = "";
        }
      })
    }).catch(err => {
      console.log(err)
    })
    e.value = null;
  }

  refreshDataFromServer() {
    // this._firebase.getModuleData()

    /*setTimeout(() => {
      if (this.selectedFolder == 'root')
        this.setSelectedFolder({ node: null, contentData: null })
      else
        this.setSelectedFolder({ node: this.selectedFolder, contentData: this.contentData })
    }, 100)*/

    /*console.log(this._sharedVar.selectedDevice)
    this._firebase.getModuleFromDevice('media', this._sharedVar.selectedDevice.data.group, this._sharedVar.selectedDevice.data.name).then(d => {
      console.log("DATA SERVER:", d.data.fileTree)
    })*/
    this._ref.detectChanges();
  }

  /* importElement(data) {
     if (this.selectedFolder == 'root') {
       console.log("MEDIA DATA:", data)
       this.contentData.push(data);
      // this._firebase.getModuleFromDevice('media', this._sharedVar.selectedDevice.)
     }
   }*/


  openColorSelection() {

    let _data = {
      type: 'color',
      title: this.translation.transform('colorTextDisplay'),
      currentValue: this.defaultBackgroundColor,
      buttonLabel: 'Valider',
      buttonColor: 'accent'
    }



    this.dialogRef = this.dialog.open(ModalMainComponent, {
      height: '350px',
      data: _data,
    })


    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.defaultBackgroundColor = result.currentValue
        if (this.selectedFolder == 'root') {
          this._firebase.updateModule(this.moduleId, { defaultColor: result.currentValue, latestUpdate: new Date() })
          this.config.defaultColor = result.currentValue;
        }

        else {
          this._firebase.updateMediaData({ defaultColor: result.currentValue }, this.selectedFolder.id).then(() => {
            this._firebase.updateModule(this.moduleId, { latestUpdate: new Date() })
          })
        }
      }
    })


  }


  /* TEMPORARY */
  triggerGenerateFileTree() {
    this._firebase.generateDefaultFileTree('DEV MODE').then(d => {
      console.log("GENERATED FILETREE", d)
      this.contentData = d;
      this._firebase.updateConfigModule({ fileTree: this.contentData, latestUpdate: this.latestUpdate }, this.moduleId).then(l => {
        this.latestUpdate = l;
      })
    })
  }

  rename(elem) {
    // console.log(id)


    //    console.log(elem)
    let tmp
    if (elem.displayName)
      tmp = elem.displayName.replace(`.${elem.name.split('.')[elem.name.split('.').length - 1]}`, '')
    else
      tmp = elem.name.replace(`.${elem.name.split('.')[elem.name.split('.').length - 1]}`, '')
    //   console.log(tmp)
    var _data = {

      type: 'text',
      title: this.translation.transform('enterNewName'),
      buttonLabel: this.translation.transform('validate'),
      currentValue: tmp,//elem.name.split('.')[elem.name.split('.').length - 1],
      buttonColor: 'accent',
    };


    this.dialogRef = this.dialog.open(ModalMainComponent, {

      height: '50vh',
      data: _data
    })

    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {


        if (elem.type != 'file') {
          this._utils.renameNode(result.currentValue, elem.id, this.contentData)


          this._firebase.updateMediaName(elem.id, result.currentValue, elem).then(() => {
            this._firebase.updateConfigModule({ fileTree: this.contentData, latestUpdate: this.latestUpdate }, this.moduleId).then(d => {
              this.latestUpdate = d;
            })
          })

        }
        else if (elem.type == 'file') {

          let extension = elem.name.split('.')[elem.name.split('.').length - 1]

          this._utils.renameNode(`${result.currentValue}.${extension}`, elem.id, this.contentData)


          this._firebase.updateMediaDisplayName(elem.id, result.currentValue, elem).then(() => {
            this._firebase.updateConfigModule({ fileTree: this.contentData, latestUpdate: this.latestUpdate }, this.moduleId).then(d => {
              this.latestUpdate = d;
            })
          })

        }
        /*if (result.currentValue.length > 0)
 
 
          if (item != undefined)
            this.addElementToChildren(item.id, result.currentValue, 'folder').then((data) => {
              this._firebase.updateConfigModule({ fileTree: data }, this.moduleId)
            })
          else {
            this.addElementToChildren(null, result.currentValue, 'folder').then((data) => {
              this._firebase.updateConfigModule({ fileTree: data }, this.moduleId)
            })
          }*/
        /*

        this._utils.renameNode(result.currentValue, node.id, this.dataSource)

        this._firebase.updateMediaName(node.id, result.currentValue).then(() => {
          this._firebase.updateConfigModule({ fileTree: this.dataSource }, this.moduleId)
        })*/
      }

    });

    /*.then((d) => {
 
    })*/

    //this._firebase.updateMediaName(node.id, node.name)

  }


  setElementVisibility(item) {
    // console.log(item)

    if (item.mediaOptions.active != undefined)
      item.mediaOptions.active = !item.mediaOptions.active
    else
      item.mediaOptions.active = false;

    this._firebase.updateMediaData({ active: item.mediaOptions.active }, item.id)
    this._firebase.updateModule(this.moduleId, { latestUpdate: new Date() })

  }


  setElementLock(item) {
    if (item.mediaOptions.lock != undefined)
      item.mediaOptions.lock = !item.mediaOptions.lock
    else
      item.mediaOptions.lock = true;

    this._firebase.updateMediaData({ lock: item.mediaOptions.lock }, item.id)
    this._firebase.updateModule(this.moduleId, { latestUpdate: new Date() })
  }


  checkType(name, item) {


    //   console.log("FILENAME:", name, name.match(/.(jpg|jpeg|png|gif)$/i))

    //  console.log(item)
    if (name.match(/.(jpg|jpeg|png|gif)$/i) != null)
      return 'img';
    else
      return false;
  }

  ngOnInit() {
    /*  if (this._firebase.user.role != 'subuser' && (this._firebase.user.subuid != '96oXRJRiaBNX5fWzodHlXlBrnUr2' || !isDevMode())) {
        this.setSelectedFolder({ node: null, contentData: null })
  
      }*/




  }


  /* manageDisplayThumbnail() {
     let thumbnail = document.getElementById("thumbnail") as any;
     let backgroundThumbnail = document.getElementById("backgroundThumbnail") as any;
 
 
 
    // console.log(thumbnail, backgroundThumbnail, thubmnail)
     //console.log(thumbnail.src)
 
     console.log("ELEMENT:", backgroundThumbnail.src)
     if (thumbnail != undefined) {
       thumbnail.style.display = "";
 
       if (thumbnail.src == undefined) {
         thumbnail.style.display = "none";
         this.loadingThumbnail = true;
       }
 
       thumbnail.onerror = (err) => {
         thumbnail.style.display = "none";
 
         this.loadingThumbnail = false;
       }
 
 
       thumbnail.onload = () => {
         thumbnail.style.display = "";
         this.loadingThumbnail = true;
       }
 
 
     }
     else if(thumbnail == undefined){
       this.loadingThumbnail = true;
     }
 
     if (backgroundThumbnail != undefined) {
       backgroundThumbnail.style.display = "";
       console.log(backgroundThumbnail.src)
       if (backgroundThumbnail.src == undefined) {
         backgroundThumbnail.style.display = "none";
         this.loadingBackgroundThumbnail = true;
       }
 
       backgroundThumbnail.onerror = (err) => {
         console.log(err)
         backgroundThumbnail.style.display = "none";
         this.loadingBackgroundThumbnail = true;
       }
       backgroundThumbnail.onload = () => {
         backgroundThumbnail.style.display = "";
         this.loadingBackgroundThumbnail = true;
       }
     }
     else if (backgroundThumbnail == null) {
       this.loadingBackgroundThumbnail = true;
     }
   }*/


  onErrorImg(type, e) {

    // console.log("Error loading img")
    e.target.style.display = 'none';
    if (type == 'thumbnail') {
      this.loadingThumbnail = true;
    }
    if (type == 'backgroundThumbnail') {
      this.loadingBackgroundThumbnail = true;
    }
    if (type == 'logo') {
      this.loadingLogo = true;
    }
    this._ref.detectChanges();
  }

  onLoadImg(type, e) {

    //  console.log("Img loaded")
    e.target.style.display = '';
    if (type == 'thumbnail') {
      this.loadingThumbnail = true;
    }
    if (type == 'backgroundThumbnail') {
      this.loadingBackgroundThumbnail = true;
    }
    if (type == 'logo') {
      this.loadingLogo = true;
    }
    this._ref.detectChanges();
  }


  clickOnUpload(id) {
    let elem = document.getElementById(id);

    //console.log("CLICK ON UPLOAD")
    elem.click();
  }


  removeLogo(url) {


    this.dialogRef = this.dialog.open(ConfirmModalComponent, {

      height: '50vh',
      data: { title: this.translation.transform('warningDeleteImage'), ok: 'Oui', cancel: this.translation.transform('cancel') }
    })


    this.dialogRef.afterClosed().subscribe(result => {
      //console.log(result)
      if (result) {

        this._firebase.removeLogo(url, this._sharedVar.selectedDevice.data.group, this._sharedVar.selectedDevice.data.name).then(d => {
          this.logoUrl = null;
        })
      }


    })
    /**/

  }

  removeBackground(urlBackground) {

    this.config.rootBackgroundAsset = null;
    this.config.latestUpdate = new Date();
    this.folderBackgroundAssetsUrl = null;
    if (this.selectedFolder == 'root') {
      this._firebase.removeImg(urlBackground);


    }
    else {
      this._firebase.removeImg(urlBackground);
      let removeBackgroundAssetName = (tab) => {
        tab.forEach(item => {
          if (item.id == this.selectedFolder.id)
            item.backgroundAssetName = null;

          if (item.children && item.children.length > 0)
            removeBackgroundAssetName(item.children)
        })
      }


      removeBackgroundAssetName(this.config.fileTree);

      this._firebase.updateMediaData({ background: { firestoragePath: "", url: "" }, }, this.selectedFolder.id)
    }

    this._firebase.updateModule(this.moduleId, this.config)
  }


  setHeaderData() {
    this._firebase.updateConfigModule({ enableHeader: this.enableHeader, latestUpdate: this.latestUpdate }, this.moduleId).then(d => {
      this.latestUpdate = d;
    })
  }

  setDisplayElementName() {
    console.log("SET ELEMENT NAME", this.contentArray, this.selectedFolder, this.hideElementName)

    console.log(this.selectedFolder.id)
    if (this.selectedFolder.id) {
      this._firebase.updateMediaData({ hideElementName: this.hideElementName }, this.selectedFolder.id)
      this._firebase.updateConfigModule({ latestUpdate: this.latestUpdate }, this.moduleId).then(d => {
        this.latestUpdate = d;
      })
    }
    else
      this._firebase.updateConfigModule({ hideElementName: this.hideElementName, latestUpdate: this.latestUpdate }, this.moduleId).then(d => {
        this.latestUpdate = d;
      })

  }

  setStyle(style: string) {
    this.mediaStyle = style;


    //   console.log(this.mediaStyle);
    this._firebase.updateConfigModule({ mediaStyle: this.mediaStyle, latestUpdate: this.latestUpdate }, this.moduleId).then(d => {
      this.latestUpdate = d;
    })

  }

  setDisplayStyle(style: string) {
    this.displayStyle = style
    this._firebase.updateConfigModule({ displayStyle: this.displayStyle, latestUpdate: this.latestUpdate }, this.moduleId).then(d => {
      this.latestUpdate = d;
    })
  }


  ngAfterViewInit() {


  }



}
